// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import formatHomepageTitles from "./formatHomepageTitles";
import preventSingleWordWrap from "./preventSingleWordWrap";
import initHeroTilt from "./hero-tilt-init";
import "./hero-underline-animation";
import "./scroll-reveal";
import "./testimonials";
import "./load-more-archive";
import "./comment-redirect";
import initHeadingAnchors from "./heading-anchors";


// Call the menu functions
menuOpen();
formatHomepageTitles();
preventSingleWordWrap();
initHeadingAnchors();
// Hero tilt is initialized in hero-tilt-init.js (handles its own DOM ready)
